module.exports = __webpack_public_path__ + "static/media/time-stamp.c41f2109.png";